// extracted by mini-css-extract-plugin
module.exports = {"cloud-transfer-container":"CloudTransfer_cloud-transfer-container__50JEl"};